





















import Vue from "vue";

export default Vue.extend({
    name: "My",
    data() {
        return {
            loading: false,
            count: 16,
            appInfo: {
                document: {
                    computedStyleFontSize: "",
                    computedStyleWidth: "",
                    fontSize: "",
                    lineHeight: "",
                    clientWidth: 0
                },
                screen: {
                    width: 0
                },
                devicePixelRatio: 0,
                scale: 0
            }
        };
    },
    mounted() {
        this.getAppInfo();
    },
    methods: {
        resetRootFontSize() {
            const timeout = setTimeout(() => {
                const width = document.documentElement.clientWidth;
                document.documentElement.style.fontSize = (width / 375) * ++this.count + "px";
                clearTimeout(timeout);
            }, 600);
        },
        getAppInfo() {
            this.appInfo.document.computedStyleFontSize = window.getComputedStyle(document.documentElement).fontSize;
            this.appInfo.document.computedStyleWidth = window.getComputedStyle(document.documentElement).width;
            this.appInfo.document.fontSize = document.documentElement.style.fontSize;
            this.appInfo.document.lineHeight = document.documentElement.style.lineHeight;
            this.appInfo.document.clientWidth = document.documentElement.clientWidth;
            this.appInfo.screen.width = window.screen.width;
            this.appInfo.devicePixelRatio = window.devicePixelRatio;
            this.appInfo.scale = window.screen.width / document.documentElement.clientWidth;
        }
    }
});
